import React from 'react';
import { Menu, Dropdown, Icon } from 'antd';
import { dispatch } from '@@/store'
import { logout } from '../../services/user';

const menu = (
  <Menu>
    <Menu.Item>
      <a target="_blank" rel="noopener noreferrer" href="/#/dashboard/info">
        查看资料
      </a>
    </Menu.Item>
    <Menu.Item onClick={() => { dispatch.user.logout() }}>
      退出
    </Menu.Item>
  </Menu>
)

export default function ({ name = '', handleLogout }) {
  return <Dropdown overlay={menu}>
    <a className="ant-dropdown-link" style={{
      // width: 100,
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
    }}>
      <div style={{
        overflow: 'hidden',
        width: '14em',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        flex: 1
      }}>{name}</div>
      <div style={{ marginLeft: '0.3em', marginRight: '1em' }}>
      <Icon type="down" style={{  }} />
      </div>
    </a>
  </Dropdown>
}